/* z-index must live on the Positioner — it is the positioned ancestor (see tooltip.module.css) */
.positioner {
  z-index: var(--tuna-zIndex-tooltip);
}

.popup {
  position: relative;
  background-color: var(--tuna-surface-elevated);
  color: var(--tuna-content-primary);
  border: 1px solid var(--tuna-border-subtle);
  border-radius: var(--tuna-shape-radius-lg);
  box-shadow: var(--tuna-shadow-4);
  font-family: var(--tuna-typography-fontFamily);
  transform-origin: var(--transform-origin);
  transition:
    opacity 120ms ease-out,
    transform 120ms ease-out;
}

.popup[data-starting-style],
.popup[data-ending-style] {
  opacity: 0;
  transform: scale(0.97);
}

@media (prefers-reduced-motion: reduce) {
  .popup {
    transition: none;
  }
}

/* A rotated square sharing the popup's surface and border; base-ui positions it on the edge facing the trigger */
.arrow {
  width: 12px;
  height: 12px;
  background-color: var(--tuna-surface-elevated);
  border: 1px solid var(--tuna-border-subtle);
  transform: rotate(45deg);
}

.arrow[data-side='bottom'] {
  top: -7px;
  border-right: none;
  border-bottom: none;
}

.arrow[data-side='top'] {
  bottom: -7px;
  border-left: none;
  border-top: none;
}

.arrow[data-side='left'] {
  right: -7px;
  border-left: none;
  border-bottom: none;
}

.arrow[data-side='right'] {
  left: -7px;
  border-right: none;
  border-top: none;
}
